import { prop, propOr } from 'ramda';
import './typedef';

class LabCallout {
  constructor(payload) {
    /** @type {string} */
    this.name = prop('name', payload);
    /** @type {string} */
    this.type = prop('type', payload);
    /** @type {Locale[]} */
    this.locales = (propOr([], 'locales', payload) || []).map(
      locale => new Locale(locale)
    );
  }
}

class Locale {
  constructor(payload) {
    /** @type {string} */
    this.locale = prop('locale', payload);
    /** @type {string} */
    this.content = prop('content', payload);
    /** @type {Banner{}} */
    this.banner = new Banner(propOr({}, 'banner', payload));
    /** @type {Alert{}} */
    this.alert = prop('alert', payload)
      ? new Alert(prop('alert', payload))
      : new Alert();
  }
}

class Banner {
  constructor(payload) {
    /** @type {string} */
    this.alt = prop('alt', payload);
    /** @type {string} */
    this.img = prop('img', payload);
    /** @type {string} */
    this.maxWidth = prop('maxWidth', payload);
  }
}

class Alert {
  constructor(payload) {
    /** @type {string} */
    this.type = prop('type', payload);
    /** @type {string} */
    this.header = prop('header', payload);
    /** @type {string} */
    this.content = prop('content', payload);
  }
}

export class EHCustomCallouts {
  constructor(payload) {
    /** @type {LabCallout[]} */
    this.labs = propOr([], 'labs', payload).map(
      callout => new LabCallout(callout)
    );
  }
}
